import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface CustomerRequest {
    manager_name: string;
    manager_mobile: string;
    manager_email: string | null;
}

export const usePostCustomerManager = (
    successCallback?: () => void,
    customerId?: number,
): UseMutationResult<null, Error, CustomerRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, CustomerRequest>({
        mutationFn: async (customerManagerData: CustomerRequest) => {
            try {
                const response = await axios.post(
                    enum_api_uri.post_customer_manager.replace(":customer_idx", customerId?.toString() || ""),
                    customerManagerData,
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    },
                );
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getCustomerManager"] });
            queryClient.invalidateQueries({ queryKey: ["getCustomerList"] });
            successCallback?.();
        },
        // onError: (error: Error) => {
        //     console.error("고객 생성 실패:", error);
        // },
        // isError로 수정해보기
    });
};
